import { a as e, n as t, o as n } from "./client-C353vByp.js";
import { n as r, r as i } from "./store-CfeUiT2k.js";
import { useCallback as a, useEffect as o, useRef as s, useState as c } from "react";
//#region src/callback.ts
function l(e) {
	let { client: n } = r(), [i] = c(() => new URLSearchParams(window.location.search)), [l, u] = c("processing"), d = s(null), f = s(!1), p = s(null);
	return o(() => {
		if (!n) return;
		let a = !0;
		return window.history.replaceState(window.history.state, "", window.location.pathname), d.current ||= (async () => {
			if (i.has("error")) throw new t("authorization_rejected", "Authorization was not completed");
			let e = await n.handleCallback(i.get("code") || "", i.get("state") || "");
			return r.getState().setAuth(e.user, e.sessionData), n.getReturnPath();
		})(), d.current.then((t) => {
			a && e(t);
		}, (e) => {
			a && (console.warn("[auth] callback_rejected", { reason: e instanceof t ? e.reason : "callback_failed" }), u("failed"));
		}), () => {
			a = !1;
		};
	}, [
		n,
		e,
		i
	]), {
		status: l,
		restart: a(async () => {
			if (n && !f.current) {
				f.current = !0, u("restarting");
				try {
					p.current ??= n.getReturnPath(), await n.initiateSSO(p.current);
				} catch {
					console.warn("[auth] callback_restart_failed"), f.current = !1, u("restart_failed");
				}
			}
		}, [n])
	};
}
//#endregion
//#region src/organization.ts
function u(e) {
	return e === 401 || e === 403 ? "forbidden" : e === 404 ? "not_found" : e >= 500 ? "server" : "unknown";
}
function d() {
	let { user: t } = r(), { apiUrl: l } = i(), [d, f] = c([]), [p, m] = c(!!t?.id), [h, g] = c(null), [_, v] = c(null), y = s(!1), b = s(null);
	return o(() => {
		t?.id ? y.current && b.current === t.id || (b.current = t.id, (async () => {
			m(!0), g(null), v(null);
			let e;
			try {
				e = await fetch(`${l}/v1/users/me/organizations`, {
					method: "GET",
					credentials: "include",
					headers: { Accept: "application/json" }
				});
			} catch (e) {
				g(e instanceof Error ? e.message : "Failed to fetch organizations"), v("network"), m(!1);
				return;
			}
			if (!e.ok) g(`Failed to fetch organizations: ${e.status}`), v(u(e.status)), m(!1);
			else try {
				let t = await e.json(), r = n(Array.isArray(t) ? t : t.organizations ?? []);
				f(r), y.current = !0;
			} catch (e) {
				g(e instanceof Error ? e.message : "Failed to fetch organizations"), v("unknown");
			} finally {
				m(!1);
			}
		})()) : (f([]), y.current = !1, b.current = null);
	}, [t?.id, l]), {
		active: d.find((e) => e.id === t?.organizationId) ?? null,
		all: d,
		isLoading: p,
		error: h,
		errorCode: _,
		switchOrg: a(async (t, n) => {
			g(null), v(null);
			let r;
			try {
				r = await fetch(`${l}/v1/users/me/switch-organization`, {
					method: "POST",
					credentials: "include",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ organization_id: t })
				});
			} catch (e) {
				g(e instanceof Error ? e.message : "Failed to switch organization"), v("network");
				return;
			}
			if (r.ok) n?.redirectTo === void 0 ? window.location.reload() : window.location.assign(e(n.redirectTo));
			else {
				let e = await r.json().catch(() => ({}));
				g(e?.message ?? `Switch failed: ${r.status}`), v(u(r.status));
			}
		}, [l])
	};
}
//#endregion
export { l as n, d as t };

//# sourceMappingURL=organization-CsI1biu8.js.map